/* istanbul ignore file */
import { useEffect, useState } from 'react';
import { LoadDropdown, useInputHelper, Option } from 'framework/form';
import { ResultResourceData } from 'framework/crud';
import useProjectService from '../projectService';

interface Props {
  source: string;
  label?: string;
  showLoader?: boolean;
  placeholder?: string;
  disabled?: boolean;
  isVisible?: boolean | ((data: any) => boolean);
  loadDataMethod?: () => ResultResourceData;
  mapResults?: (data: any) => Option;
}

const ProjectSuggestionDropdown = ({ loadDataMethod, mapResults: mapResultsFromProps, ...props }: Props) => {
  const { searchAllSuggestions } = useProjectService();
  const { getRawOnChangeCallback } = useInputHelper(props);
  const rawOnChangeCallback = getRawOnChangeCallback();
  const [loadedProjects, setLoadedProjects] = useState<any[]>([]);

  const mapResults = (project: ResultResourceData) => ({
    value: project.id,
    label: `${project.projectName} (SOW Number: ${project.sowId})`,
    accountId: project.accountId,
    sowId: project.sowId,
  });

  const loadProjects = async () => {
    const projects = await searchAllSuggestions({});
    setLoadedProjects(projects);

    return {
      result: projects,
    };
  };

  const onChangeCallback = (values: any) => {
    const projectId = values[props.source];
    const projectData = projectId ? loadedProjects.find(data => data.id === projectId) : {};

    if (rawOnChangeCallback) {
      rawOnChangeCallback({ project: { projectId, accountId: projectData.accountId, sowId: projectData.sowId } });
    }
  };

  useEffect(() => {
    return () => {
      if (rawOnChangeCallback) {
        rawOnChangeCallback({ project: null });
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LoadDropdown
      loadDataMethod={loadProjects}
      mapResults={mapResultsFromProps || mapResults}
      showLoader
      onChangeCallback={onChangeCallback}
      placeholder="Select Project"
      {...props}
    />
  );
};

export default ProjectSuggestionDropdown;
